<template>
    <span>
      {{statusDisplay}}
      <rp-icon
        v-if="status === 'paid'"
        type="remove_circle_outline"
        tooltip="odznacz opłacenie"
        @click="setNotPaid"
      />
      <v-menu offset-y v-if="status !== 'paid'">
          <rp-icon
            slot="activator"
            type="add_circle_outline"
            tooltip="zaznacz opłacenie"
          />
      <v-list>
        <v-list-tile
          @click="setPaid('cash')"
        >
          <v-list-tile-title>paragon - gotówka</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="setPaid('transfer')"
        >
          <v-list-tile-title>paragon - przelew</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="setPaid('no_receipt')"
        >
          <v-list-tile-title>bez paragonu</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    </span>
</template>

<script>
import {paidPayment, unpaidPayment} from './api'
import iziToast from 'izitoast'

export default {
  props: ['status', 'id'],
  computed: {
    'statusDisplay': function () {
      let value = this.status
      if (value === 'paid') {
        return 'Opłacono'
      } else if (value === 'exceeded') {
        return 'Termin przekroczony'
      } else if (value === 'unpaid') {
        return 'Nieopłacone'
      }
      return ''
    }
  },
  methods: {
    setPaid (type) {
      paidPayment(this.id, type).then((data) => {
        this.$emit('change', true)
        iziToast.show({
          message: 'Opłacono',
          color: 'green'
        })
      })
    },
    setNotPaid () {
      unpaidPayment(this.id).then((data) => {
        this.$emit('change', false)
        iziToast.show({
          message: 'Odznaczono opłacenie',
          color: 'green'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/payments/PaymentStatus.vue